/* SET STATE */
export const SET_STATE_LABTYPE = "SET_STATE_LABTYPE"

/* LAB TYPES */
export const GET_LABTYPES = "GET_LABTYPES"
export const GET_LABTYPES_SUCCESS = "GET_LABTYPES_SUCCESS"
export const GET_LABTYPES_FAIL = "GET_LABTYPES_FAIL"

/* LAB TYPE */
export const GET_LABTYPE = "GET_LABTYPE"
export const GET_LABTYPE_SUCCESS = "GET_LABTYPE_SUCCESS"
export const GET_LABTYPE_FAIL = "GET_LABTYPE_FAIL"

/**
 * ADD LAB TYPE
 */
 export const ADD_NEW_LABTYPE = "ADD_NEW_LABTYPE"
 export const ADD_LABTYPE_SUCCESS = "ADD_LABTYPE_SUCCESS"
 export const ADD_LABTYPE_FAIL = "ADD_LABTYPE_FAIL"

 /**
 * UPDATE LAB TYPE
 */
export const UPDATE_LABTYPE = "UPDATE_LABTYPE"
export const UPDATE_LABTYPE_STATUS = "UPDATE_LABTYPE_STATUS"
export const UPDATE_LABTYPE_SUCCESS = "UPDATE_LABTYPE_SUCCESS"
export const UPDATE_LABTYPE_FAIL = "UPDATE_LABTYPE_FAIL"

/**
 * DELETE LAB TYPE
 */
export const DELETE_LABTYPE = "DELETE_LABTYPE"
export const DELETE_LABTYPE_SUCCESS = "DELETE_LABTYPE_SUCCESS"
export const DELETE_LABTYPE_FAIL = "DELETE_LABTYPE_FAIL"
